(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product-clean"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.card-clean__quick-add[data-product-id]').forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const variantId = this.dataset.productId;
        const btn = this;

        if (btn.classList.contains('is-loading')) return;

        btn.classList.add('is-loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        })
        .then(response => response.json())
        .then(data => {
          btn.classList.remove('is-loading');

          // Trigger cart drawer open if available
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }

          // Dispatch custom event for cart update
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));

          // Update cart count in header
          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              const cartCountBubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
              if (cartCountBubble) {
                cartCountBubble.textContent = cart.item_count;
              }
              const cartCountVisual = document.querySelector('.cart-count-bubble');
              if (cartCountVisual && cart.item_count > 0) {
                cartCountVisual.style.display = '';
              }
            });
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          btn.classList.remove('is-loading');
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
